import { z } from 'zod'

const _pastDate = z.coerce
  .date()
  .refine(
    (d) => d > new Date('2009-01-01T00:00:00Z') && d <= new Date(),
    'Date must be between 2009-01-01 and now',
  )
const _dateAfter2009 = z.coerce
  .date()
  .refine(
    (d) => d > new Date('2009-01-01T00:00:00Z'),
    'Date must be after 2009',
  )

const _loggerRecord = z
  .object({
    battery: z.number().optional(),
    humidity: z.number().optional(),
    ts: _pastDate.optional(),
    tamper: z
      .object({
        charge: z.boolean().optional(),
        mag: z.boolean().optional(),
        case: z.boolean().optional(),
        accel: z.boolean().optional(),
        gps: z.boolean().optional(),
        wireless: z.boolean().optional(),
        survival: z.boolean().optional(),
      })
      .optional(),
    temp: z.number().optional(),
    temperature: z
      .object({ min: z.number().optional(), max: z.number().optional() })
      .optional(),
  })
  .passthrough()

export const legacyReadingBodySchema = z
  .object({
    id: z.union([z.string(), z.number().int()]).optional(),
    record: z
      .object({ id: z.number().int().optional(), table: z.string().optional() })
      .optional(),
    cable: z
      .array(
        z
          .object({
            serial: z.number().int().optional(),
            onewire_id: z
              .string()
              .regex(/^[0-9a-f]+$/)
              .optional(),
            ts: _pastDate.optional(),
            readings: z.array(z.number()).optional(),
          })
          .passthrough(),
      )
      .optional(),
    raw_readings: z.array(z.number()).optional(),
    snow_depth: z.number().optional(),
    snow_depth_raw: z.number().optional(),
    sonic: z
      .array(
        z
          .object({ ts: _pastDate.optional(), range: z.number().optional() })
          .passthrough(),
      )
      .optional(),
    barometer: z
      .array(
        z
          .object({ ts: _pastDate.optional(), pressure: z.number().optional() })
          .passthrough(),
      )
      .optional(),
    radar: z
      .array(
        z
          .object({
            serial: z.number().int().optional(),
            ts: _pastDate.optional(),
            readings: z
              .array(
                z
                  .object({
                    ts: _pastDate.optional(),
                    distance: z.number().int().optional(),
                  })
                  .passthrough(),
              )
              .optional(),
          })
          .passthrough(),
      )
      .optional(),
    data: z
      .object({
        packet: z.unknown().optional(),
        format: z.number().int().optional(),
      })
      .optional(),
    geo: z
      .object({
        lat: z.number().optional(),
        lon: z.number().optional(),
        cep_radius: z.number().int().optional(),
        cep: z.number().int().optional(),
      })
      .optional(),
    logger: z.union([_loggerRecord, z.array(_loggerRecord)]).optional(),
    modem: z
      .object({
        battery: z.number().optional(),
        imei: z.string().length(15).regex(/^\d+$/).optional(),
        momsn: z.number().int().optional(),
        retries: z.number().int().optional(),
      })
      .optional(),
    loggerSerial: z.string().optional(),
    site: z
      .array(
        z
          .object({
            id: z.number().int().optional(),
            air_temp: z.number().optional(),
            airtc_avg: z.number().optional(),
            snow_depth: z.number().optional(),
            rain: z.number().optional(),
            readings: z.array(z.number()).optional(),
            rh: z.number().optional(),
          })
          .passthrough(),
      )
      .optional(),
    ts: z
      .object({
        email: _pastDate.optional(),
        record: _pastDate.optional(),
        satellite: _pastDate.optional(),
        created: _pastDate.optional(),
        updated: _pastDate.optional(),
        deleted: _dateAfter2009.optional(),
        expired: _dateAfter2009.optional(),
        locked: _dateAfter2009.optional(),
        archived: _dateAfter2009.optional(),
        unsubscribed: _dateAfter2009.optional(),
      })
      .optional(),
    wind: z
      .object({
        speed: z.record(z.string(), z.unknown()).optional(),
        dir: z.record(z.string(), z.unknown()).optional(),
      })
      .optional(),
    by_user: z
      .object({
        username: z.string().optional(),
        id: z.union([z.number().int(), z.string().uuid()]).optional(),
      })
      .optional(),
    v: z.number().int().optional(),
    requests: z
      .array(
        z
          .object({
            type: z.string().optional(),
            date: _dateAfter2009.optional(),
            onewire_id: z
              .string()
              .regex(/^[0-9a-f]+$/)
              .optional(),
            serial: z.number().int().optional(),
          })
          .passthrough(),
      )
      .optional(),
  })
  .passthrough()
